import { Location } from "@angular/common";
import { AfterContentInit, AfterViewInit, Component, ComponentRef, createComponent, EnvironmentInjector, OnDestroy, OnInit, TemplateRef, ViewChild, ViewContainerRef, ViewRef } from '@angular/core';
import { AppStateService } from "ng/src/app/core/services/app-state.service";
import { Utils } from "ng/src/app/core/utils";
import { LogService } from "ng/src/app/logs/log.service";
import { Shift } from "ng/src/app/shifts/shift.model";
import { ShiftsService } from "ng/src/app/shifts/shifts.service";
import { ShiftSignOnComponent } from "ng/src/app/shifts/sign-on/shift-sign-on.component";
import { CookieService } from "ngx-cookie-service";
import { Observable, Subject } from "rxjs";
import { filter, take, takeUntil } from "rxjs/operators";

@Component({
  selector: 'single-shift-sign-on',
  templateUrl: './single-shift-sign-on.component.html',
  styleUrls: ['./single-shift-sign-on.component.scss']
})
export class SingleShiftSignOnComponent implements AfterViewInit, OnDestroy {
  
  @ViewChild('shiftSignOnComponent') shiftSignOnComponent?: ShiftSignOnComponent;
  
  constructor(
    public logService: LogService,
    public shiftService: ShiftsService,
    public appState: AppStateService,
    private cookieService: CookieService
  ) {}
  
  callbackIsValid = false;
  readonly _destroy$ = new Subject<void>();
  
  get showSignOn() {
    const userShifts = this.shiftService.activeShifts
      .filter((shift) => shift.user.id == this.appState.currentUser?.id && shift.log.id == this.logService.selectedLog?.id);
    
    return !userShifts.length || this.shiftSignOnComponent?.signOnCompleted;
  }
  
  getCallbackUrl(): string | undefined {
    let shiftCallback: string | undefined | null = this.cookieService.get('shift-callback');
    if (!shiftCallback) {
      shiftCallback = AppStateService.urlSearchParamsGet('callback');
    }
    
    return shiftCallback ?? undefined;
  }
  
  sendCallback(shift: Shift | undefined, success: boolean): void {
    if (!this.callbackIsValid) return;
    
    const callbackUrl = this.getCallbackUrl();
    if (!callbackUrl) {
      this.callbackIsValid = false;
      return;
    }
    
    try {
      const url = new URL(callbackUrl);
      url.searchParams.set('success', success.toString());
      url.searchParams.set('shiftId', shift?.id.toString() ?? '-1');
      
      window.location.href = url.toString();
    }
    catch (e) {
      //ignore
    }
  }
  
  private validateCallback() {
    const callbackUrl = this.getCallbackUrl();
    this.callbackIsValid = !!callbackUrl;
  }
  
  ngAfterViewInit(): void {
    this.validateCallback();
    this.appState.locationChanged$.pipe(
      takeUntil(this._destroy$)
    )
    .subscribe(() => {
      this.validateCallback();
    });
    
    this.shiftService.fetchActiveUserShifts()
      .pipe(
        takeUntil(this._destroy$),
        take(1),
        filter(() => !this.showSignOn)
      )
      .subscribe((shifts) => {
        this.sendCallback(shifts[0], false);
      });
  }
  
  ngOnDestroy(): void {
    this._destroy$.next();
  }
}
